import React from 'react';
import type { ClassNameProp, ClosableComponentProps } from '../common-types';
import { Tool } from './Tool';
import { intl } from '../../lib';

/**
 * Props for a {@link Tag} component.
 */
export interface TagProps extends ClassNameProp, ClosableComponentProps {
  /**
   * Label of the tag.
   */
  label: string;

  /**
   * An optional custom color to use when you want to have a different color for the border of the element.
   * You can and **should** use color variables for this property. For example `var(--support-1)`.
   */
  color?: string;
}

/**
 * Tag component used to display contextual information or showing categories mapped to some content.
 * @param properties a {@link TagProps} object
 * @returns JSX.ELement
 * @constructor
 */
export function Tag({
  label,
  className = '',
  closable = false,
  color,
  ...props
}: Readonly<TagProps>): React.JSX.Element {
  return (
    <div
      {...props}
      className={`ehs-tag s-font ${className}`.trim()}
      style={
        color
          ? {
              borderColor: color
            }
          : undefined
      }
    >
      <span className="tag-label">{label}</span>
      {closable && (
        <Tool
          className="close-tool"
          icon="materialicon-close"
          onClick={closable.onClose}
          tooltip={intl('view.button.close')}
        />
      )}
    </div>
  );
}
